import { AxiosError } from "axios";

type NestErrorBody = { message?: string | string[] };

/** מחזיר הודעת שגיאה קריאה מתשובת RPC / axios או מ-Error מקומי */
export function getRpcErrorMessage(
  error: unknown,
  fallback = "אירעה שגיאה, אנא נסה שנית",
): string {
  if (error instanceof AxiosError) {
    const body = error.response?.data as NestErrorBody | undefined;
    const message = body?.message;
    if (typeof message === "string" && message.length > 0) return message;
    if (Array.isArray(message) && message.length > 0) {
      return message.join(", ");
    }
  }
  if (error instanceof Error && error.message) {
    return error.message;
  }
  return fallback;
}
